import {
  BreederProfileAboutScreen,
  BreederProfileAboutScreenProps,
} from 'shared/screens/breeders/profile/breeder-profile-about';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';
import { getBreederProfileSeoTitle } from '@web/library/breeder-profile-seo';
import { BreederProfilePage } from '@web/components/breeder-profile-page';

export default function BreederIndex(props: BreederProfileAboutScreenProps) {
  const { t } = useTranslation('screens');
  const title = getBreederProfileSeoTitle(props.breeder, t);

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(title)
          .setDescription(props.breeder.description ?? '')
          .setImage(props.breeder.avatar?.url)
      }
    >
      <BreederProfilePage breeder={props.breeder} mediaAssets={props.mediaAssets}>
        <BreederProfileAboutScreen {...props} />
      </BreederProfilePage>
    </Page>
  );
}

export const getServerSideProps = withServerProps(BreederProfileAboutScreen.pageBuilder);
